import axios from 'axios'; // You'll need to import axios
import { urlBase } from "./API"

// ===============================================
// === User's Existing Functions (from your file) ===
// ===============================================

// Get Report Mock 
export const getReportMock = async (mockId, classId, userId) => {
    return axios({
        method: "GET",
        url: `${urlBase}/api/classes/${classId}/mocks/${mockId}/report?userId=${userId}`
    })
}

export const getReportForStd = async (data, classId,
    studentId,
    userId) => {
    return axios({
        method: "POST",
        url: `${urlBase}/api/classes/${classId}/students/${studentId}/report?userId=${userId}`,
        data: data
    })
}

// Send Report To All Std by lesson
export const addReportToAllStd = (data,classId,lessonId,userId)=>{
    return axios({
        method:"POST",
        url:`${urlBase}/api/classes/${classId}/lessons/${lessonId}/report?userId=${userId}`,
        data:data,
    })
}

export const addReportManyLesson = (data,classId,userId)=>{
    return axios({
        method:"POST",
        // url:`${urlBase}/api/classes/${classId}/lessons/${lessonId}/report?userId=${userId}`,
        url:`${urlBase}/api/classes/${classId}/reports/many/lessons?userId=${userId}`,
        data:data,
    })
}

export const sendReportToClass = (data, userId) => {
  return axios({
    method: 'POST',
    // url: `${urlBase}/api/send-class-report-all-students`,
    url: `${urlBase}/api/send-custom-class-report?userId=${userId}`,
    data: data,
    withCredentials: true
  })
}

// ==========================================================
// === NEW Functions Based on Your reports.routes.js File ===
// ==========================================================

// get Activity (H.W + Attendance)Report Of Class
// (This one was already in your file and matches the new router)
export const getActivityReportOfClass = (classId, from, to, userId) => {
  return axios({
    method: 'GET',
    url: `${urlBase}/api/v2/reports/${classId}/activity?from=${from}&to=${to}&userId=${userId}`,
  })
}

/**
 * Corresponds to:
 * router.route('/reports/:classId/mock/periodic')
 * .get(reportsController.getMockReportOfClass)
 */
export const getPeriodicMockReportOfClass = (classId, from, to, userId) => {
  return axios({
    method: 'GET',
    url: `${urlBase}/api/v2/reports/${classId}/mock/periodic?from=${from}&to=${to}&userId=${userId}`,
  });
};

/**
 * Corresponds to:
 * router.route('/reports/:classId/lessons')
 * .post(reportsController.getClassLessonsActivityReport)
 */
export const getClassLessonsActivityReport = (data, classId, userId) => {
  return axios({
    method: 'POST',
    url: `${urlBase}/api/v2/reports/${classId}/lessons?userId=${userId}`,
    data: data, // data should be: { lessonIds: [...] }
  });
};

/**
 * Corresponds to:
 * router.route('/reports/:classId/lesson/:lessonId')
 * .get(reportsController.getSingleLessonActivityReport)
 */
export const getSingleLessonActivityReport = (classId, lessonId, userId) => {
  return axios({
    method: 'GET',
    url: `${urlBase}/api/v2/reports/${classId}/lesson/${lessonId}?userId=${userId}`,
  });
};

/**
 * Corresponds to:
 * router.route('/reports/:classId/mock/:mockId')
 * .get(reportsController.mockClassReports)
 */
export const getMockClassReport = (classId, mockId, userId) => {
  return axios({
    method: 'GET',
    url: `${urlBase}/api/v2/reports/${classId}/mock/${mockId}?userId=${userId}`,
  });
};

// Send Custom Report To Student

export const sendCustomReportToStudent = ( classId, studentId,from,to,about ,userId) => {
  return axios({
    method: 'POST',
    url: `${urlBase}/api/send-custom-student-report?userId=${userId}`,
    data: { classId, studentId, from, to, about },
    withCredentials: true
  });
}